<template>
  <div class="container-fluid" style="background-image: url('./Image/back.jpg'); background-size: cover; height: 100vh">
    <loading v-if="loadingRender"></loading>
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10 mt-5">
        <net-pa-card v-if="stage == 1 && Islogin == undefined">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-unlock"></i> احراز هویت
              <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <div class="row">
                <div class="col-12 text-center">
                  <h6>برای دریافت کد احراز هویت کد ملی و شماره موبایل خود را وارد کنید.</h6>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <form id="div1" class="w-100">
                    <div class="row">
                      <div class="col-3"></div>

                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <input class="form-control text-center mt-2 required-CodeMeli" style="direction: ltr" type="number" v-model="CodeMeli" placeholder="کد ملی" />
                        </div>
                        <div class="col-12 p-2">
                          <input class="form-control text-center required mt-2" style="direction: ltr" type="number" v-model="Mobile" placeholder="شماره موبایل " />
                        </div>
                      </div>
                      <div class="col-3"></div>
                      <div class="col-3"></div>
                      <div class="col-md-6 col-12 row">
                        <div class="col-12 p-2">
                          <button class="btn btn-submit w-100 mt-2" @click.prevent="sendSms">ارسال پیامک</button>
                        </div>
                      </div>
                    </div>
                    <div class="col-3"></div>
                  </form>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>

        <net-pa-card v-if="stage == 2 && Islogin == undefined">
          <template slot="header">
            <h6 class="text-right"><i class="fas fa-unlock"></i> احراز هویت</h6>
          </template>
          <template slot="content">
            <div class="row p-3">
              <div class="col-12 text-center">
                <h6>کد پیامک شده خود را وارد کنید</h6>
              </div>
              <div class="col-md-4"></div>
              <div class="col-md-4 col-12">
                <div class="row">
                  <div class="col-12 mt-2 mb-2">
                    <input type="number" placeholder="کد احراز هویت" class="form-control text-center" style="direction: ltr" v-model="randomKey" autocomplete="off" maxlength="6" id="txtRandoKey" />
                  </div>
                  <div class="col-12 mt-2">
                    <button class="btn w-100 btn-submit" @click="OkCode()">ثبت کد</button>
                  </div>
                </div>
              </div>
              <div class="col-md-4"></div>
            </div>
          </template>
        </net-pa-card>
        <net-pa-card v-else-if="stage == 3 || Islogin == true">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-sign-in-alt"></i> درخواست عضویت
              <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی" class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
            </h6>
          </template>
          <template slot="content">
            <div class="container">
              <form id="Register">
                <div class="row">
                  <div class="alert w-100 bg-dark-Custom text-right">
                    <span class="text-light">اطلاعات فردی</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> نــــام : </small>
                    <input autocomplete="off" @keypress="$ValidPersian($event, 20)" type="text" id="OzvName" class="form-control InputText required" v-model="OzvName" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> نام خانوادگی : </small>
                    <input autocomplete="off" @keypress="$ValidPersian($event, 40)" type="text" id="OzvFamily" class="form-control InputText required" v-model="OzvFamily" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> کد ملی : </small>
                    <input autocomplete="off" type="number" maxlength="10" class="form-control InputText required-CodeMeli text-left" @keypress="$ValidNumber($event, 10)" @input="$CheckupLengthCodeMeli($event)" v-model="CodeMeli" :disabled="Islogin == undefined" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> تاریخ تولد : </small>
                    <date-picker :editable="true" v-model="BirthDate" color="#ff9800"></date-picker>
                    <input type="text" tabindex="-1" class="d-none InputText required" v-model="BirthDate" style="direction: ltr" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> شماره شناسنامه : </small>
                    <input autocomplete="off" type="number" maxlength="10" @keypress="$ValidNumber($event, 10)" v-model="Shenasname" id="Shenasname" class="form-control InputText" style="direction: ltr" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> نام پدر : </small>
                    <input autocomplete="off" v-model="Pedar" type="text" @keypress="$ValidPersian($event, 50)" id="pedar" class="form-control text-right InputText required" style="direction: rtl" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> جنسیت : </small>
                    <select class="form-control text-center Pointer required" id="cmbSEX" v-model="cmbSEX" style="max-height: 100px !important">
                      <option selected class="Pointer" :value="4041">مرد</option>
                      <option class="Pointer" :value="4042">زن</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> وضعیت تاهل : </small>
                    <select class="form-control text-center Pointer required" id="cmbTaahol" v-model="cmbTaahol" style="max-height: 100px !important">
                      <option selected class="Pointer" :value="4068">مجرد</option>
                      <option class="Pointer" :value="4067">متاهل</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> محل صدور : </small>
                    <input autocomplete="off" v-model="Sodor" type="text" @keypress="$ValidPersian($event, 50)" id="Sodor" class="form-control text-right InputText" style="direction: rtl" />
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="alert w-100 bg-dark-Custom text-right">
                    <span class="text-light">اطلاعات تماس</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> شماره همراه : </small>
                    <input autocomplete="off" type="number" @keypress="$ValidNumber($event, 11)" id="Mobile" class="form-control InputText required" style="direction: ltr" v-model="Mobile" :disabled="Islogin == undefined" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-secondary"> تلفن تماس : </small>
                    <input autocomplete="off" type="number" @keypress="$ValidNumber($event, 11)" id="Tel" class="form-control InputText" style="direction: ltr" v-model="Tel" />
                  </div>
                  <!-- <div class="col-md-4 col-12">
                                    <small class="text-right text-secondary">  محل کار:  </small>
                                    <input autocomplete="off"  type="text"  id="Work" class="form-control InputText " style="direction:rtl;" v-model="Work" >
                                </div> -->
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> آدرس منزل : </small>
                    <textarea autocomplete="off" type="text" id="Address" class="form-control InputText text-right" rows="1" style="direction: ltr" v-model="Address"></textarea>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="alert w-100 bg-dark-Custom text-right">
                    <span class="text-light">اطلاعات بانکی</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> شماره حساب بانکی : </small>
                    <input autocomplete="off" type="number" @keypress="$ValidNumber($event, 20)" id="Mobile" class="form-control InputText required" style="direction: ltr" v-model="HesabNo" />
                  </div>
                  <div class="col-md-4 col-12">
                    <small class="text-right text-dark"> انتخاب بانک : </small>
                    <select name="cmbBank" id="cmbBank" class="form-control Pointer" v-model="ResultcmbBank">
                      <option selected v-for="item in this.ListModelBank" :key="item.id" :value="item.id">
                        <span>{{ item.bankName }}</span>
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="alert w-100 bg-dark-Custom text-right">
                    <span class="text-light">سایر اطلاعات</span>
                  </div>
                  <div class="col-md-3 col-12">
                    <small v-if="$session.get('CustCode') == '801'" class="text-right text-dark"> شعبه مورد نظر جهت عضویت : </small>
                    <small v-else class="text-right text-dark">
                      {{ txtTafsilytype }}
                    </small>
                    <Dropdown v-if="Islogin == undefined" :options="OptionsvalidateSelection2" v-on:selected="validateSelectionShobe" :disabled="false" name="TafsiliType" :maxItem="50000" placeholder="انتخاب"> </Dropdown>
                    <small class="text-right text-secondary" v-else>{{ nameTafsiliType }}</small>
                  </div>
                  <div class="col-md-3 col-12">
                    <small v-if="$session.get('CustCode') == '801'" class="text-right text-dark"> محل کار مورد نظر جهت عضویت : </small>
                    <small v-else class="text-right text-dark">
                      {{ txtAzaNo }}
                    </small>
                    <Dropdown v-if="Islogin == undefined" :options="OptionsvalidateSelection" v-on:selected="validateSelection" :disabled="false" name="zipcode" :maxItem="50000" placeholder="انتخاب"> </Dropdown>
                    <small class="text-right text-secondary" v-else>{{ nameAzanoe }}</small>
                    <!-- <select v-if="IsLoad" name="cmbAzaNoe" id="cmbAzaNoe" class="form-control Pointer" @change="GetAzaNoe()" v-model="ResultcmbcmbAzaNoeArray">
                                            <option  v-if="this.IsLoad==false" value="-2"> || در حال بارگذاری ، منتظر بمانید ... || </option>
                                            <option  selected  value="-1" >-- انتخاب محل کار --</option>
                                            <option v-for="item in this.ListModelAzaNoe"   :key="item.id" :value="item" >
                                                <span>{{item.nameHoze}}</span>
                                            </option>
                                        </select> -->
                  </div>

                  <!-- <div class="col-md-3 col-12">
                                        <small class="text-right text-dark"> شعبه افتتاح حساب :  </small>

                                       <select v-if="IsLoad" name="cmbTafsiliType" id="cmbTafsiliType" class="form-control Pointer"  v-model="ResultcmbcmbTafsiliType" disabled >
                                            <option selected v-for="item in this.ListModelTafsiliType" :key="item.id" :value="item.id" >
                                                <span>{{item.nameTafsiliType}}</span>
                                            </option>
                                        </select> 
                                    </div> -->
                  <div class="col-md-3 col-12">
                    <small class="text-right text-dark"> عضویت به عنوان : </small>
                    <br />
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline1" name="customRadioInline" class="custom-control-input" @click="changeRdo" :checked="rdoAsli && Islogin == undefined" :disabled="Islogin" />
                      <label class="custom-control-label" for="customRadioInline1">عضو اصلی</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline2" name="customRadioInline" class="custom-control-input" @click="changeRdo" :checked="Islogin" />
                      <label class="custom-control-label" for="customRadioInline2">عضو وابسته</label>
                    </div>
                  </div>
                  <div v-if="IsVabaste != ''" class="col-md-3 col-12">
                    <small class="text-right text-secondary"> کد ملی عضو اصلی: </small>
                    <div class="input-group mb-3">
                      <input autocomplete="off" type="number" maxlength="10" class="form-control InputText required-CodeMeli text-left" @keypress="$ValidNumber($event, 10)" @input="$CheckupLengthCodeMeli($event)" v-model="CodeMeliVabaste" :disabled="Islogin" />
                      <div class="input-group-prepend">
                        <button class="btn btn-outline-secondary" @click="CheckCodemeli()" type="button" id="button-addon1">بررسی</button>
                      </div>
                    </div>
                    <span class="text-danger">مشخصات عضو اصلی : </span>
                    <span class="text-dark"> {{ Moshakhasat }}</span>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="alert w-100 bg-dark-Custom text-right">
                    <div class="row text-light">
                      <span>آپلود مدارک</span>
                      <h6 class="mx-2" v-if="$cookies.isKey('RegisterForm') & ($session.get('CustCode') == 886)">
                        - برای دانلود فرم عضویت
                        <a :href="$cookies.get('RegisterForm')" download="فرم عضویت"><sapn class="badge badge-success">اینجا </sapn></a> کلیک کنید.
                      </h6>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <input type="file" @change="changefile" class="d-none" id="Uploader" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf" />
                    <button class="btn btn-primary" @click.prevent="clickUploader">برای بارگذاری مدارک کلیک کنید</button>
                  </div>
                  <div class="col-md-6 col-12">
                    <small class="text-secondary"> نام فایل: </small>

                    <small v-if="fileinfo.name">
                      {{ fileinfo.name }}
                    </small>
                    <br />
                    <br />
                    <small class="text-secondary"> حجم فایل: </small>
                    {{}}
                    <small v-if="fileinfo.size"> {{ (fileinfo.size / 1000000).toFixed(2) }} MB </small>
                  </div>
                </div>
              </form>
              <div class="row mt-2">
                <div class="col-12">
                  <hr />
                </div>
                <div class="col-md-8 col-12"></div>
                <div class="col-md-4 col-12">
                  <button class="btn btn-block btn-lg btn-success" @click="SabtOzv()">ثبت اطلاعات</button>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import loading from '../Tools/NetPa/Loading.vue'
import Dropdown from 'vue-simple-search-dropdown'
export default {
  data() {
    return {
      txtAzaNo: 'دسته بندی',
      txtTafsilytype: 'نوع عضویت',
      stage: 1,
      OzvName: '',
      OzvFamily: '',
      CodeMeli: null,
      BirthDate: '',
      Shenasname: null,
      Pedar: '',
      cmbSEX: null,
      cmbTaahol: null,
      Sodor: '',
      Mobile: '',
      Tel: null,
      Work: '',
      Address: '',
      cmbShobe: null,
      ResultcmbcmbAzaNoeArray: null,
      IsLoad: false,
      ListModelAzaNoe: null,
      loadingRender: false,
      DataAxios: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EftetahHesab/NewAzaNetPa',
        Token: '',
      },
      DataAxiosUpload: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EftetahHesab/SaveAttachmentToDb',
        Token: '',
      },
      rdoAsli: true,
      CodeMeliVabaste: '',
      IsVabaste: false,
      Moshakhasat: '',
      wwwtblAzaIdSahebHesab: null,
      ListModelTafsiliType: null,
      ResultcmbcmbTafsiliType: null,
      fileinfo: {},
      OptionsvalidateSelection: [],
      OptionsvalidateSelection2: [],
      ListModelTafsily: null,
      ListModelBank: null,
      ResultcmbBank: null,
      HesabNo: null,
      randomKey: '',
      bnpCashDbtblTafsiliTypeId: null,
      nameTafsiliType: '',
      nameAzanoe: '',
      IdEftetah: 0,
    }
  },
  components: {
    NetPaCard,
    datePicker: VuePersianDatetimePicker,
    loading,
    Dropdown,
  },
  props: ['Islogin'],
  mounted() {
    this.randomKey = ''

    if (this.Islogin == true && this.Islogin != undefined) {
      // console.log(this.$session.get("UserInfoNetPa"));
      this.rdoAsli = false
      this.IsVabaste = true
      this.CodeMeliVabaste = this.$session.get('UserInfoNetPa').codeMeli.trim()
      this.Moshakhasat = JSON.parse(JSON.stringify(this.$session.get('UserInfoNetPa'))).ozvName + ' ' + JSON.parse(JSON.stringify(this.$session.get('UserInfoNetPa'))).ozvFamily
      this.wwwtblAzaIdSahebHesab = this.$session.get('UserInfoNetPa').id
      var formdata2 = new FormData()
      formdata2.append('custcode', this.$session.get('CustCode'))
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata2,
        Method: 'Post',
        Action: 'TafsiliType/GetAll',
        Token: '',
      }

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          // console.log(res);
          this.ListModelTafsily = res
          var a = res.filter((i) => i.id == this.$session.get('UserInfoNetPa').wwwtblTafsiliTypeId)
          this.nameTafsiliType = a[0].nameTafsiliType
          this.ResultcmbcmbTafsiliType = a
          this.loadingRender = false
          this.bnpCashDbtblTafsiliTypeId = a[0].bnpCashDbtblTafsiliTypeId
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: '',
            Action: 'TafsiliType/GetTblBank',
            method: 'post',
            Token: '',
          })
            .then((res) => {
              this.ListModelBank = res
              this.ResultcmbBank = res[0].id
            })
            .finally(() => {
              this.loadingRender = true
              var formdata = new FormData()
              formdata.append('BnpId', this.bnpCashDbtblTafsiliTypeId)
              formdata.append('custcode', this.$session.get('CustCode'))
              var DataAxios_TafsiliType = {
                ArryfildValue: formdata,
                Method: 'Post',
                Action: 'AzaNoe/GetIndex',
                Token: '',
              }
              this.$PostFormData(DataAxios_TafsiliType)
                .then((data) => {
                  var b = data.filter((x) => x.id == this.$session.get('UserInfoNetPa').wwwtblAzaNoeId)
                  this.nameAzanoe = b[0].nameHoze
                  this.ResultcmbcmbAzaNoeArray = b
                })
                .finally(() => {
                  this.loadingRender = false
                })
            })
        })
    } else {
      var formdata = new FormData()
      formdata.append('custcode', this.$session.get('CustCode'))
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'TafsiliType/GetAll',
        Token: '',
      }

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          this.ListModelTafsily = res
          for (let index = 0; index < this.ListModelTafsily.length; index++) {
            const element = this.ListModelTafsily[index]
            if (element.id != 3527160) {
              var option = {
                name: element.nameTafsiliType,
                id: element,
              }

              this.OptionsvalidateSelection2.push(option)
            }
          }
          this.loadingRender = false
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: '',
            Action: 'TafsiliType/GetTblBank',
            method: 'post',
            Token: '',
          }).then((res) => {
            this.ListModelBank = res
            this.ResultcmbBank = res[0].id
          })
        })
    }
  },
  updated() {},
  methods: {
    // GetAzaNoe(){
    //     if(this.ResultcmbcmbAzaNoeArray!=undefined){
    //     if(this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId>0 ){
    //         var formdata = new FormData()
    //         formdata.append("BnpId" , this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId)
    //         var DataAxios_TafsiliType = { ArryfildValue: formdata,Method: "Post",Action: "TafsiliType",Token: ''}
    //         this.$PostFormData(DataAxios_TafsiliType).then(data =>{
    //             this.ListModelTafsiliType=null
    //             this.ListModelTafsiliType=data
    //             this.ResultcmbcmbTafsiliType=data[0].id
    //         })

    //     }
    //     else{
    //         this.$mySweetDefaultTost('عملیات ناموفق', ' مشکل در بارگذاری شعبه مذکور', 'error', 4000)
    //         this.ResultcmbcmbTafsiliType=null
    //                     return;
    //     }
    //     }
    // },
    sendSms() {
      if (this.$ValidForm('div1')) {
        if (this.CodeMeli == '') {
          this.$mySweetDefaultTost('خطا', ' کد ملی نمیتواند خالی باشد.', 'error', 2000)
        }
        if (this.Mobile == '') {
          this.$mySweetDefaultTost('خطا', '  شماره همراه نمیتواند خالی باشد.', 'error', 2000)
        }
        if (this.Mobile.length != 11) {
          this.$mySweetDefaultTost('خطا', '  شماره همراه 11 رقمی است.', 'error', 2000)
        } else {
          this.loadingRender = true
          var DataAxiosRegisterAuth = {
            ArryfildValue: {},
            Action: 'EftetahHesab/RegisterAuth',
            Method: 'POST',
            Token: '',
          }
          const formData = new FormData()
          formData.append('mobile', this.Mobile)
          formData.append('codeMeli', this.CodeMeli)
          DataAxiosRegisterAuth.ArryfildValue = formData
          this.$PostFormData(DataAxiosRegisterAuth)
            .then((data) => {
              this.$mySweetDefaultTost(' ', data.msg, data.icone, 3000)
              if (data.status == 'Ok') {
                this.stage = 2
                this.loadingRender = false
              } else {
                this.stage = 1
                this.loadingRender = false
              }
            })
            .finally(() => {
              document.getElementById('txtRandoKey').focus()
            })
        }
      }
    },
    OkCode() {
      this.loadingRender = true
      var DataAxiosDataAxiosRegisterAuth = {
        ArryfildValue: {},
        Action: 'EftetahHesab/RegisterOK',
        Method: 'POST',
        Token: '',
      }
      const formData = new FormData()

      formData.append('codeMeli', this.CodeMeli)
      formData.append('randomKey', this.randomKey)
      DataAxiosDataAxiosRegisterAuth.ArryfildValue = formData
      this.$PostFormData(DataAxiosDataAxiosRegisterAuth).then((data) => {
        this.$mySweetDefaultTost(' ', data.msg, data.icone, 4000)
        if (data.status == 'Ok') {
          this.stage = 3
          this.GetDataRegister()
          this.loadingRender = false
        } else {
          this.loadingRender = false
          this.stage = 2
        }
      })
    },
    SabtOzv() {
      if (this.$requiredCodeMeli('Register')) {
        if (this.$ValidForm('Register')) {
          if (this.IsVabaste) {
            if (this.CodeMeliVabaste == '') {
              this.$mySweetDefaultTost('عملیات ناموفق', ' لطفا کد کلی فرد اصلی را وارد نمایید ', 'error', 4000)
              return
            }
            if (this.CodeMeliVabaste == this.CodeMeli) {
              this.$mySweetDefaultTost('عملیات ناموفق', ' کد ملی وارد شده با کد ملی فرد وابسته نمیتواند یکسان باشد ', 'error', 4000)
              return
            }
            if (this.wwwtblAzaIdSahebHesab == 0) {
              this.$mySweetDefaultTost('عملیات ناموفق', ' کد ملی وارد شده برای فرد اصلی معتبر نمیباشد', 'error', 4000)
              return
            }
          }
          if (this.ResultcmbcmbTafsiliType == null || this.ResultcmbcmbAzaNoeArray == undefined) {
            this.$mySweetDefaultTost('عملیات ناموفق', ' اتخاب محل کار و شعبه افتتاح کننده حساب اجباری است', 'error', 4000)
            return
          }
          this.loadingRender = true
          this.DataAxios.ArryfildValue = {
            OzvName: this.OzvName,
            OzvFamily: this.OzvFamily,
            Pedar: this.Pedar,
            Shenasname: this.Shenasname,
            Email: '',
            MahalSodor: this.Sodor,
            CodeMeli: this.CodeMeli,
            Adres: this.Address,
            Tel: this.Tel,
            Mobile: this.Mobile,
            tblComboIdSex13: this.cmbSEX,
            tblComboIdTahol19: this.cmbTaahol,
            wwwtblTafsiliTypeId: this.Islogin == undefined ? this.ResultcmbcmbTafsiliType.id : this.ResultcmbcmbTafsiliType[0].id,
            wwwtblAzaNoeId: this.Islogin == undefined ? this.ResultcmbcmbAzaNoeArray.id : this.ResultcmbcmbAzaNoeArray[0].id,
            PerNo: 0,
            HesabNo: this.HesabNo,
            tblBankId: this.ResultcmbBank,
            wwwtblAzaIdSahebHesab: this.wwwtblAzaIdSahebHesab != null ? this.wwwtblAzaIdSahebHesab : 0,
            BirthDate: this.BirthDate,
          }
          this.$PostData(this.DataAxios)
            .then((data) => {
              if (data.status == 'NoSUCCESS_2') {
                this.loadingRender = false
                this.$mySweetDefaultTost('عملیات ناموفق', ' درخواست عضویت شما قبلا ثبت شده است لطفا نتیجه را از شعبه استعلام نمایید ', 'error', 4000)
                return
              } else if (data.status == 'NoSUCCESS_1') {
                this.loadingRender = false
                this.$mySweetDefaultTost('عملیات ناموفق', ' شما در حال حاضر عضو میباشید و امکان درخواست عضویت وجود ندارد', 'error', 4000)
                return
              } else {
                this.IdEftetah = data.id
                this.loadingRender = false
                this.$mySweetDefaultTost('عملیات موفق', 'درخواست شما با موفقیت ثبت شد.', 'success', 5000)
              }
            })
            .finally(() => {
              if (document.getElementById('Uploader').files[0]) {
                this.loadingRender = false
                var formdata = new FormData()
                formdata.append('IdEftetah', this.IdEftetah)
                formdata.append('Image', document.getElementById('Uploader').files[0])
                this.DataAxiosUpload.ArryfildValue = formdata
                this.$PostFormData(this.DataAxiosUpload).then((data) => {
                  if (data.status == 'Ok') {
                    this.loadingRender = false
                    this.$router.push({ name: 'LoginPage' })
                    return
                    //this.$mySweetDefaultTost('عملیات موفق', 'درخواست شما با موفقیت ثبت شد.', 'success', 3000)
                  } else {
                    this.loadingRender = false
                    this.$mySweetDefaultTost('عملیات ناموفق', ' مشکلی در بارگذاری مدارک بوجود آمده است. دوباره تلاش کنید', 'error', 4000)
                    return
                  }
                })
              } else {
                this.loadingRender = false
                this.$router.push({ name: 'LoginPage' })
                return
              }
            })
        }
      } else {
        this.$mySweetDefaultTost('عملیات ناموفق', ' فرمت کد ملی نامعتبر میباشد ', 'error', 3000)
        return
      }
    },
    changeRdo() {
      if (this.rdoAsli) {
        this.rdoAsli = false
        this.IsVabaste = true
      } else {
        if (!this.rdoAsli) {
          this.rdoAsli = true
          this.IsVabaste = false

          this.CodeMeliVabaste = ''
          this.Moshakhasat = ''
        }
      }
    },
    CheckCodemeli() {
      var formdata = new FormData()
      formdata.append('Codemeli', this.CodeMeliVabaste)
      var DataAxiosGetuser = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'getCodeMeli',
        Token: '',
      }
      this.$PostFormData(DataAxiosGetuser).then((data) => {
        if (data.status == 'OK') {
          this.Moshakhasat = data.data
          this.wwwtblAzaIdSahebHesab = data.id
          this.$mySweetDefaultTost('', '', 'success', 1000)
        } else {
          this.wwwtblAzaIdSahebHesab = 0
          this.$mySweetDefaultTost('عملیات ناموفق', '  کد ملی نامعتبر میباشد ', 'error', 3000)
        }
      })
    },
    clickUploader() {
      document.getElementById('Uploader').click()
    },
    changefile() {
      if (document.getElementById('Uploader').files[0].size > 1024 * 1024 * 5) {
        this.$mySweetDefaultTost('عملیات ناموفق', '  حجم فایل مورد نظر بیشتر از 5 مگابایت است ', 'error', 3000)
        return
      } else {
        this.fileinfo = document.getElementById('Uploader').files[0]
      }
    },
    validateSelection(data) {
      this.ResultcmbcmbAzaNoeArray = data.id
    },
    validateSelectionShobe(data) {
      this.ResultcmbcmbTafsiliType = data.id
      this.GetTafsiliType()
    },
    GetTafsiliType() {
      if (this.ResultcmbcmbTafsiliType != null && this.ResultcmbcmbTafsiliType != undefined) {
        this.loadingRender = true
        var formdata = new FormData()
        formdata.append('BnpId', this.ResultcmbcmbTafsiliType.bnpCashDbtblTafsiliTypeId)
        formdata.append('custcode', this.$session.get('CustCode'))
        var DataAxios_TafsiliType = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'AzaNoe/GetIndex',
          Token: '',
        }
        this.$PostFormData(DataAxios_TafsiliType)
          .then((data) => {
            this.ListModelAzaNoe = data
            this.OptionsvalidateSelection = []
            for (let index = 0; index < this.ListModelAzaNoe.length; index++) {
              const element = this.ListModelAzaNoe[index]
              var option = {
                name: element.nameHoze,
                id: element,
              }
              this.OptionsvalidateSelection.push(option)
            }
          })
          .finally(() => {
            this.loadingRender = false
          })
      }
    },
    GetDataRegister() {
      this.loadingRender = false
      document.getElementsByName('zipcode')[0].classList.add('form-control')
      document.getElementsByName('zipcode')[0].setAttribute('autocomplete', 'new-password')
      document.getElementsByName('TafsiliType')[0].classList.add('form-control')
      document.getElementsByName('TafsiliType')[0].setAttribute('autocomplete', 'new-password')

      this.loadingRender = false
    },
  },
  // computed:{
  //     uploaderDiv(){
  //         if (document.getElementById('Uploader').files.length>0) {
  //             return "FullDiv"
  //         }else
  //         {
  //             return "EmptyDiv"
  //         }
  //     }
  // }
}
</script>
<style scoped>
.EmptyDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.FullDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 235, 205);
  border: 2px dotted #12852f;
  border-radius: 15px;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%, rgba(72, 20, 193, 1) 100%);
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
